var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var NotificationCenter_1;
import React, { Component } from 'react';
import { FirstPage } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { ApplicationContext } from '@philips-internal/oswald-ui-core/lib/component/context/index.js';
import { arrayOf, bool, eventListener, number, object, oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { ClickEvent, CloseEvent, OpenEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { enumValues, getLostProps, isFunction, isXSmallResolution } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as BellIcon } from '../../../resources/assets/components/DLS_AlarmBell.svg';
import { ContextMenu } from '../context-menu/context-menu.js';
import { Link } from '../link/link.js';
import { Modal } from '../modal/modal.js';
import { Option } from '../option/option.js';
import { Popover } from '../popover/popover.js';
import { NotificationCenterGroups } from './components/notification-center-groups.js';
import NotificationCenterAPI from './notification-center-api.js';
import { NotificationCenterClickType } from './notification-center-constants.js';
import './notification-center.css';
let NotificationCenter = NotificationCenter_1 = class NotificationCenter extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            open: false,
        };
        this.onClick = () => {
            this.setState({ open: true });
        };
        this.onItemClick = (item, type) => {
            const { onClick } = this.props;
            const value = {
                item,
                type,
            };
            if (isFunction(onClick)) {
                onClick(new ClickEvent({ value }));
            }
        };
        this.onOpen = () => {
            const { onOpen } = this.props;
            if (isFunction(onOpen)) {
                onOpen(new OpenEvent());
            }
            this.setState({ open: true }, () => this.pushNavigationItem());
        };
        this.onMarkAllAsRead = () => {
            const { onClick } = this.props;
            const value = {
                type: NotificationCenterClickType.MARK_ALL_AS_READ,
            };
            if (isFunction(onClick)) {
                onClick(new ClickEvent({ value }));
            }
        };
        this.onClose = () => {
            const { onClose } = this.props;
            this.setState({ open: false }, () => {
                if (isFunction(onClose)) {
                    onClose(new CloseEvent());
                }
            });
        };
    }
    componentWillUnmount() {
        if (isFunction(this.popNavigationItem)) {
            this.popNavigationItem();
        }
    }
    shouldRenderMobile() {
        return isXSmallResolution();
    }
    pushNavigationItem() {
        const { open } = this.state;
        if (open && this.shouldRenderMobile()) {
            this.popNavigationItem = this.context?.pushNavigationItem(this.onClose);
        }
    }
    renderNotificationTopArea() {
        const { canMarkAllAsRead, data, title } = this.props;
        const dataIsEmpty = data?.length === 0;
        return (React.createElement("div", { className: "c-notification-center__popover-header" },
            React.createElement("span", { className: "c-notification-center__popover-title" }, MessageService.translate(title)),
            canMarkAllAsRead && !dataIsEmpty
                ? this.renderMarkAllAsRead()
                : null));
    }
    renderMarkAllAsRead() {
        const { uuid } = this.props;
        if (this.shouldRenderMobile()) {
            return (React.createElement(ContextMenu, { uuid: uuid },
                React.createElement(Option, { enabled: true, onClick: this.onMarkAllAsRead, preventDefault: true, stopPropagation: false, value: "tws.notification-center.mark-all-as-read" })));
        }
        return (React.createElement("span", { className: "c-notification-center__mark-all-as-read", onClick: this.onMarkAllAsRead }, MessageService.translate('tws.notification-center.mark-all-as-read')));
    }
    renderIcon() {
        const { unreadNotificationsCount } = this.props;
        const unreadCount = unreadNotificationsCount > 0 ? String(unreadNotificationsCount) : undefined;
        return (React.createElement(Link, { badge: unreadCount, className: "c-notification-center__icon", icon: React.createElement(BellIcon, null), onClick: this.onOpen }));
    }
    renderNotificationCenterPopover() {
        const { open } = this.state;
        return (React.createElement(Popover, { className: "c-notification-center__popover-wrapper", maxHeight: 320, onClose: this.onClose, open: open, padding: 0 },
            this.renderIcon(),
            this.renderPopoverContent()));
    }
    renderPopoverContent() {
        const { data, canDeleteNotification, canMarkAsRead, canMarkAsUnread, firstPage, limit, uuid } = this.props;
        const lostProps = getLostProps(NotificationCenter_1.propTypes, this.props);
        return (React.createElement(Popover.Content, null,
            React.createElement("div", { className: "c-notification-center__popover" },
                this.renderNotificationTopArea(),
                React.createElement(NotificationCenterGroups, { ...lostProps, canDeleteNotification: canDeleteNotification, canMarkAsRead: canMarkAsRead, canMarkAsUnread: canMarkAsUnread, data: data, firstPage: firstPage, limit: limit, onItemClick: this.onItemClick, uuid: uuid }))));
    }
    renderNotificationCenterModal() {
        const { data, canDeleteNotification, canMarkAsRead, firstPage, limit, uuid } = this.props;
        const { open } = this.state;
        const lostProps = getLostProps(NotificationCenter_1.propTypes, this.props);
        return (React.createElement("div", null,
            this.renderIcon(),
            open && (React.createElement(Modal, { className: "c-notification-center__modal", closeable: !Modal.hasApplicationBar() || this.shouldRenderMobile(), noPadding: true, onClose: this.onClose },
                this.renderNotificationTopArea(),
                React.createElement(NotificationCenterGroups, { ...lostProps, canDeleteNotification: canDeleteNotification, canMarkAsRead: canMarkAsRead, data: data, firstPage: firstPage, limit: limit, onItemClick: this.onItemClick, uuid: uuid })))));
    }
    render() {
        if (this.shouldRenderMobile()) {
            return this.renderNotificationCenterModal();
        }
        return this.renderNotificationCenterPopover();
    }
};
NotificationCenter.contextType = ApplicationContext.Context;
NotificationCenter.propTypes = {
    canDeleteNotification: bool.group('Menu Options'),
    canMarkAllAsRead: bool.group('Menu Options'),
    canMarkAsRead: bool.group('Menu Options'),
    canMarkAsUnread: bool.group('Menu Options'),
    data: arrayOf(object).notEnumerable(),
    firstPage: oneOf(enumValues(FirstPage)),
    limit: number,
    onClick: eventListener,
    onClose: eventListener,
    onOpen: eventListener,
    title: string,
    unreadNotificationsCount: number.notEnumerable(),
    uuid: string,
};
NotificationCenter.defaultProps = {
    canDeleteNotification: true,
    canMarkAllAsRead: true,
    canMarkAsRead: true,
    canMarkAsUnread: true,
    firstPage: FirstPage.ONE,
    limit: 5,
    title: 'tws.notification.title',
    unreadNotificationsCount: 0,
};
NotificationCenter = NotificationCenter_1 = __decorate([
    AwesomeComponent({ api: NotificationCenterAPI, type: ComponentType.DATA_DISPLAY })
], NotificationCenter);
export default NotificationCenter;
//# sourceMappingURL=notification-center.js.map